<template>
  <div id="new-pathfinder">
    <img
      src="@/assets/icons/wilderverse.png"
      class="wilderverse"
    >
    <p class="is-small">SELECT YOUR</p>
    <p class="is-large">PATHFINDER</p>

    <div class="pathfinders">
      <carousel
        :perPage="1"
        :centerMode="true"
        pagination-active-color="#ffffff"
        pagination-color="rgba(213, 207, 198, .3)"
        v-on:pageChange="onPageChange($event)"
      >
        <carousel-item
          v-for="type in sortedTypes"
          :key="type.id"
        >
          <div class="pathfinder-type">
            <img :src="type.image">
            <p>{{ type.description }}</p>
          </div>
        </carousel-item>
      </carousel>
    </div>

    <button
      class="button primary"
      @click="customize()"
    >CUSTOMIZE</button>
  </div>
</template>

<script>
  import { Carousel, Slide } from "vue-carousel";
  import { mapState, mapActions, mapGetters } from "vuex";

  export default {
    components: {
      Carousel,
      "carousel-item": Slide
    },
    computed: {
      ...mapState({
        pathfinder: state => state.pathfinders.pathfinder
        // types: state => state.types.types
      }),
      ...mapGetters(["sortedTypes"])
    },
    methods: {
      ...mapActions(["newPathfinder", "softUpdatePathfinder"]),
      onPageChange(pgNumber) {
        this.softUpdatePathfinder({ type: this.sortedTypes[pgNumber].key });
      },
      customize() {
        this.$router.push({ name: "customize" });
      }
    },
    created() {
      this.newPathfinder().then(_ => {
        this.softUpdatePathfinder({ type: this.sortedTypes[0].key });
      });
    }
  };
</script>

<style lang="scss">
  @import "@/assets/global.scss";
  #new-pathfinder {
    @include jungle-background;

    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (max-width: 320px) {
      height: initial;
    }

    .wilderverse {
      width: 50%;
      margin-top: 0.5em;
      margin-bottom: 0.5em;
    }

    p.is-small {
      font-size: 0.75em;
      font-weight: bold;
      margin: 0;
    }

    p.is-large {
      font-size: 10vw;
      font-weight: bold;
      margin: 0.25em 0 0.25em 0;
    }

    .pathfinder-type {
      width: 100%;

      img {
        width: 100%;
      }

      p {
        text-align: center;
      }
    }

    button {
      margin-top: 1.5em;
      width: 85%;
    }
  }
</style>

